<div class="footer-inner">

  <div class="logo">
    <!-- <img src="/assets/logo.svg"> -->
    <a routerLink="/" class="logo-text">
      Santea
      <span class="slogan">HUMAN HEALTH</span>
    </a>
  </div>

  <div class="contact-us">
    <h2>{{ "hhPlatform.footer.question" | translate }}</h2>
    <p>
      {{ "hhPlatform.footer.contact.report" | translate }}
      <a [href]="'mailto:' + contactEmail">{{ "hhPlatform.footer.contact.issue" | translate }}</a>{{ "hhPlatform.footer.contact.contact" | translate }}<a [href]="'mailto:' + contactEmail">{{ "hhPlatform.footer.contact.support" | translate }}</a>.
    </p>
  </div>

  <div class="contact">
    <strong class="title">{{ "hhPlatform.footer.link.contactUs" | translate }}</strong>
    <a [href]="'mailto:' + contactEmail">{{ "hhPlatform.footer.link.contactSims" | translate }}</a>
  </div>

</div>
